import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWhiteBackgroundConfig } from '@/data/landingConfig/landingWhiteBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WhiteBackground } from './schemaObject';

interface Props {}
const WhiteBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WhiteBackground} />
			<LandingTemplate
				data={landingWhiteBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default WhiteBackground;
